var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "\\u30EC\\u30A4\\u30E4\\u30FC 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 17.5A1.5 1.5 0 0129 16a13 13 0 00-26 0 1.5 1.5 0 01-3 0 16 16 0 0132 0 1.5 1.5 0 01-1.5 1.5z"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    attributeType: "XML",
    type: "rotate",
    from: "0 16,16",
    to: "360 16,16",
    dur: "1s",
    repeatCount: "indefinite"
  }))));
}

export default SvgLoading;